module.exports = __webpack_public_path__ + "images/emoji/heart_eyes.081f4a76c80ac1f4c9c8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/heart_eyes.png
// module id = //gM
// module chunks = 14